module.exports = __webpack_public_path__ + "static/trailer-thumbnail-0c1acb6b4e64bc37d17930399585ed60.jpg";